<script>
import { areTranslationsLoaded, addTranslations, langIso } from '@/__shared/lang/lib_lang'
import privacyHtml from 'raw-loader!./privacy-content.html'

export default {
	lang: 'privacypage|content',
	metaInfo() {
		return { title: this.loaded ? this.$lang('Políticas de privacidad') : '' }
	},
	data() {
		return {
			loaded: areTranslationsLoaded('privacypage'),
		}
	},
	async mounted() {
		if (!this.loaded) {
			if (langIso) {
				await this.$shopApi.get('/lang-translations-by-scope', {
					query: { scope: 'privacypage', langIso },
					loading: false,
					onSuccess: ({ data }) => {
						addTranslations(data.translations, 'privacypage')
					},
				})
			}
			this.loaded = true
		}
		this.$eventer.trigger('page:view')
		this.$prerenderReady()
	},
	methods: {
		getHtml() {
			let langHtml = this.$langText('privacy-content.html')
			return langHtml == 'privacy-content.html' ? privacyHtml : langHtml
		},
	},
}
</script>

<template>
	<OtherPageLayout :loading="!loaded">
		<template #title>{{ 'Políticas de protección de datos Personales' | lang }}</template>
		<div v-html="getHtml()" />
	</OtherPageLayout>
</template>
